// Resolve the platform Home app URL relative to the current host so a
// "Home" link works across local dev (Vite on :5373), the test
// environment (home-test.goodstewardaba.com), and prod
// (home.goodstewardaba.com) without per-env config plumbing.
//
// `fromPrefix` is the calling app's own subdomain label — 'pma',
// 'admin', 'accounting', 'training'. The function swaps that leading
// fragment with 'home', which handles both bare prefixes
// (pma.goodstewardaba.com → home.goodstewardaba.com) and env-suffixed
// prefixes (pma-test.goodstewardaba.com → home-test.goodstewardaba.com).
// Hosts that don't start with the prefix fall back to prepending
// `home.` so an unrecognized deployment still produces a usable URL.
export function homeAppUrl(fromPrefix: string): string {
    if (typeof window === 'undefined') return '/';
    const { protocol, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return `${protocol}//${hostname}:5373`;
    }
    const swapped = hostname.startsWith(fromPrefix)
        ? hostname.replace(new RegExp(`^${fromPrefix}`), 'home')
        : `home.${hostname}`;
    return `${protocol}//${swapped}/`;
}
